import { createTenantClient } from './apiClient';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const api = createTenantClient(API_URL, { withCredentials: true });

export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
  logout: () => api.post('/auth/logout'),
};

export const dashboardAPI = {
  getStats: () => api.get('/dashboard/stats'),
};

export const policiesAPI = {
  list: (params = {}) => api.get('/grc/policies', { params }),
  create: (data) => api.post('/grc/policies', data),
  get: (id) => api.get(`/grc/policies/${id}`),
  update: (id, data) => api.put(`/grc/policies/${id}`, data),
  delete: (id) => api.delete(`/grc/policies/${id}`),
  getVersions: (id) => api.get(`/grc/policies/${id}/versions`),
  getVersion: (id, versionId) => api.get(`/grc/policies/${id}/versions/${versionId}`),
  restoreVersion: (id, versionId) => api.post(`/grc/policies/${id}/versions/${versionId}/restore`),
  submitForReview: (id) => api.post(`/grc/policies/${id}/submit-review`),
  exportPdf: (id) => api.get(`/grc/policies/${id}/export/pdf`, { responseType: 'blob' }),
};

export const risksAPI = {
  list: (riskLevel, status) => api.get('/risks', { params: { risk_level: riskLevel, status } }),
  create: (data) => api.post('/risks', data),
  get: (id) => api.get(`/risks/${id}`),
};

export const vendorsAPI = {
  list: () => api.get('/vendors'),
  create: (data) => api.post('/vendors', data),
};

export const alertsAPI = {
  list: (severity, status) => api.get('/alerts', { params: { severity, status } }),
};

export const cloudAPI = {
  getCloudTrailEvents: (hours = 24) => api.get('/cloudtrail/events', { params: { hours } }),
  getAzureEvents: (hours = 24) => api.get('/azure/events', { params: { hours } }),
};

export const auditAPI = {
  getLogs: (params = {}) => api.get('/audit-logs', { params }),
};

export default api;